import { useKeycloak } from '@react-keycloak/web';

export const useAuth = () => {
  const { keycloak } = useKeycloak();

  return {
    keycloak,
  };
};
